/* eslint-disable no-unused-vars */
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import logoutImg from "../../assets/logout.svg";
import chat from "../../assets/chats.svg";
import bell from "../../assets/bell.svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import GradientButton from "../common/GradientButton";
import OutlinedButton from "../common/OutlinedButton";
import LogoutDialog from "./LogoutDialog";
import useOrganizationContext from "../../context/OrgContext";
import constant from "../../constant";
import ChatTray from "./ChatTray";
import { getAllChatMessages } from "../../api/chat";
import { readCompanyBranding } from "../../utils/companyBranding";
import { redirectToDigitalProfile } from "../../utils/digitalProfile";
import emptyOrg from "../../assets/defaultOrg.svg";
import "./TopBar.css";

const TopBar = () => {
  const chatIconRef = useRef(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { logout } = useAuth();
  const { userData, displayUser, displayOrganization } = useOrganizationContext();
  const [brandingTick, setBrandingTick] = useState(0);
  useEffect(() => {
    const onBrandingUpdated = () => setBrandingTick((value) => value + 1);
    window.addEventListener("ge3s:company-branding-updated", onBrandingUpdated);
    return () => {
      window.removeEventListener("ge3s:company-branding-updated", onBrandingUpdated);
    };
  }, []);
  const { companyLogo: sharedCompanyLogo } = readCompanyBranding();
  void brandingTick;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [UnreadNotification, setUnreadNotification] = useState([]);
  const open = Boolean(anchorEl);
  console.log("userData", userData);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await getAllChatMessages();
        // console.log("response" ,response)
        if (response.success) {
          // console.log("response data", response.data.messages)
          setUnreadNotification(response.data.totalUnReadMessages);
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages(); // Initial fetch
    const intervalId = setInterval(fetchMessages, 5000); // Fetch every 5 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
  console.log("fetching messages", UnreadNotification);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  // Handle the dialog open/close
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    // Perform logout
    logout();
    handleDialogClose();
  };

  const isProfileImageValid =
    userData?.profileImage !== "null" &&
    userData?.profileImage !== null &&
    userData?.profileImage !== undefined &&
    userData?.profileImage !== "";

  const organizationLogo = displayOrganization?.logo
    ? `${constant.IMG_URL}/${displayOrganization.logo}`
    : sharedCompanyLogo || "";

  const profileAvatarSrc =
    organizationLogo ||
    (isProfileImageValid
      ? `${constant.IMG_URL}/${userData?.profileImage}`
      : emptyOrg);

  return (
    <div className="si_topbar">
      <div ref={chatIconRef} className="si_topbar-icon-wrap">
        <img
          src={chat}
          alt="logo"
          height={28}
          width={28}
          style={{ cursor: "pointer" }}
          onClick={() => setIsChatOpen(!isChatOpen)}
        />
        <div className="si_topbar-badge">{UnreadNotification}</div>
      </div>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <img
          src={bell}
          alt="logo"
          height={28}
          width={28}
          style={{ cursor: "pointer" }}
        />
        <div
          style={{
            position: "absolute",
            height: "13px",
            width: "13px",
            backgroundColor: "#FF3A3A",
            borderRadius: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: "-5px",
            right: "-2px",
            color: "#fff",
            fontSize: "8px",
          }}
        >
          1
        </div>
      </div> */}
      <div className="si_topbar-profile" onClick={handleClick}>
        <img src={profileAvatarSrc} alt="profile" />
        <div>
          <div className="si_topbar-profile-name">
            {displayUser?.name || "User"}
          </div>
          <div className="si_topbar-profile-role">
            {displayUser?.role || "Admin"}
          </div>
        </div>
      </div>
      <Menu
        sx={{ borderRadius: "10px" }}
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "10px",
              p: 0,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            redirectToDigitalProfile({ newTab: true });
            handleClose();
          }}
          sx={{ padding: "10px 12px" }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img
              src={profileAvatarSrc}
              alt="logo"
              height={25}
              width={25}
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
            <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>
              Manage Account
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDialogOpen(); // Open the confirmation dialog
            handleClose();
          }}
          sx={{ padding: "10px 12px" }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img src={logoutImg} alt="logo" height={24} width={24} />
            <Typography
              variant="subtitle1"
              sx={{ color: "#F27878", fontSize: "14px" }}
            >
              Logout
            </Typography>
          </Box>
        </MenuItem>
      </Menu>

      {/* Logout Confirmation Dialog */}
      {/* <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        
          <OutlinedButton onClick={handleDialogClose}>Cancel</OutlinedButton>
          <GradientButton onClick={handleLogout}>Yes</GradientButton>
        </DialogActions>
      </Dialog> */}

      <LogoutDialog
        open={openDialog}
        onClose={handleDialogClose}
        onConfirm={handleLogout}
        text='Do you want to logout?'
      />
      <ChatTray
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        anchorRef={chatIconRef}
      />
    </div>
  );
};

export default TopBar;
